import { render, staticRenderFns } from "./CenteredBox.vue?vue&type=template&id=2d0b0b2b&scoped=true&"
var script = {}
import style0 from "./CenteredBox.vue?vue&type=style&index=0&id=2d0b0b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b0b2b",
  null
  
)

export default component.exports